import { twMerge } from 'tailwind-merge';

import Box from './box';
import { BoxElement } from './types';

const ChatAnswerBlock = ({ children, className }: BoxElement) => {
  return (
    <Box
      className={twMerge(
        'flex flex-col gap-3 p-3 rounded-2xl shadow-lg',
        'bg-white/20 backdrop-blur-sm',
        'min-w-[350px] min-h-[200px] max-w-full max-h-full',
        className,
      )}
    >
      {children}
    </Box>
  );
};

export default ChatAnswerBlock;
